<template>
  <main
    role="main"
    class="vtd-main-section"
    :style="{
      backgroundImage:
        'url(https://cdn.trailfinders.com/hy50gj7p6n_bg-viewtrail.jpg)',
    }"
  >
    <article class="vtd-section-info">
      <slot />
    </article>
    <LoadingSpinner />
  </main>
</template>

<script>
import LoadingSpinner from "@/partials/spinner";
export default {
  components: {
    LoadingSpinner,
  },
};
</script>

<style>
@import "./styles.scss";
</style>
